import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { ShellComponent } from '@core/layout/shell/shell.component';

/**
 * @title: App Routes
 * @since: 0.0.1
 * 
 * @description: This file contains the routes for the application. It defines the main routes and their corresponding components.
 * The routes are lazy-loaded to improve performance and reduce the initial load time of the application.
 * The AuthGuard is used to protect the routes that require authentication.
 * The login route is defined separately and does not require authentication.
 * The default route redirects to the dashboard.
 * The wildcard route redirects to the dashboard if the requested route is not found.
 */
export const routes: Routes = [
	{ path: 'login', loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent) },
	{ path: '', redirectTo: 'dashboard', pathMatch: 'full' }, // Redirects empty path to dashboard
	{
		path: '',
		component: ShellComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
			{ path: 'activities', loadChildren: () => import('./features/activities/activities.module').then(m => m.ActivitiesModule) },
			{ path: 'groups', loadChildren: () => import('./features/groups/groups.module').then(m => m.GroupsModule) },
			{ path: 'leads', loadChildren: () => import('./features/leads/leads.module').then(m => m.LeadsModule) },
			{ path: 'contacts', loadChildren: () => import('./features/contacts/contacts.module').then(m => m.ContactsModule) },
		]
	},
	{ path: '**', redirectTo: 'dashboard' }, // Redirects any unknown path to dashboard
];